<template>
    <span v-if="todayIsBetweenDates(start, end)" class="todaybadge mr-2">
        {{ $t('vfair.activeNow') }}
    </span>
</template>

<script>
export default {
    name: 'OnGoingBadge',
    props: {
        start: {
            type: String,
            default: () => '',
        },
        end: {
            type: String,
            default: () => '',
        },
    },
    methods: {
        isToday(date) {
            let now = new Date();
            let then = new Date(date);
            return (
                then.getDate() === now.getDate() &&
                then.getMonth() === now.getMonth() &&
                then.getFullYear() === now.getFullYear()
            );
        },
        todayIsBetweenDates(_start, _end) {
            let today = new Date().setHours(0, 0, 0, 0);
            let start = new Date(_start).setHours(0, 0, 0, 0);
            let end = new Date(_end).setHours(0, 0, 0, 0);

            return today >= start && today <= end;
        },
    },
};
</script>

<style scoped>
.todaybadge {
    font-size: 12px;
    border: 1px;
    border-style: solid;
    border-color: var(--primary);
    border-radius: 4px;
    padding: 3px 8px 3px 8px;
    color: var(--primary);
    text-transform: uppercase;
}
</style>
